/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/appconfig-action.type';

export const getCustomRolesLimitByApp= (data:any) => ({
  type: actions.GET_CUSTOM_ROLES_LIMIT_BY_APP,
  payload: data,
});

export const getCustomRolesLimitByAppSuccess = (data:any) => ({
  type: actions.GET_CUSTOM_ROLES_LIMIT_BY_APP_SUCCESS,
  payload: data,
});

export const getCustomRolesLimitByAppError = () => ({
  type: actions.GET_CUSTOM_ROLES_LIMIT_BY_APP_FAILURE,
});
